import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import cookies from 'vue-cookies'
import Toast, {PluginOptions} from "vue-toastification";
import "vue-toastification/dist/index.css";
import { VueSelect } from "vue-select";

const globalVars = {
    data() {
        return {
            base_url: 'https://backend.agile-bpm.ir/api',
            download_url: 'https://backend.agile-bpm.ir',
            is_mother: cookies.isKey('is_mother')
             
        }
    },

}


createApp(App).component("v-select", VueSelect)
createApp(App).use(store).use(cookies).use(router).use(Toast, {rtl: true}).mixin(globalVars).mount('#app')
